import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CardSetTransformationService, DataService, DialogService, SaveFormEvent, SpinnerService } from 'dspx-core';
import { AppDataService } from 'src/app/services/app-data.service';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { POP_UP_CODES, SAVE_RESULT_STATUS } from 'src/app/constants/app-data.constants';
import { VptasSpecialistProviderInformationSaveDataRequest } from 'src/app/interfaces/vptas-specialist-provider-information-save-data-request';
import { finalize, take } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';

@Component({
  selector: 'app-vptas-specialist-provider-information',
  templateUrl: './vptas-specialist-provider-information.component.html',
  styleUrl: './vptas-specialist-provider-information.component.scss'
})
export class VptasSpecialistProviderInformationComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy {

 protected readonly fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;

 formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.vptasSpecialistProviderInformation;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  specialistId: string = '';
  
constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private dataService: DataService,
    private errorService: ErrorService,
    private spinnerService: SpinnerService,

  ) {
    super(router, appDataService, dialogService);
  }
  ngOnInit(): void {
        this.registerSubscription(
          this.route.paramMap.subscribe((paramMap: ParamMap) => {
            const specialistId = paramMap.get('specialistId');
            if (specialistId) {
              this.specialistId = specialistId;
            } else {
              throw new Error('Specialist Id is required');
            };
            const id = paramMap.get('id');
            if (id) {
              this.id = id;
              this.formServiceEndpoint = API_ENDPOINT_KEYS.getVptasSpecialistProviderConfigAndResponse;
            }
          })
        );
  }

  ngOnDestroy(): void {
     this.unsubscribeSubscriptions();
  }

  formLoaded(event: any): void {

  }

  buttonClicked(event: any): void {
  }

  filter(event: any): void {
  }

  modelChanged(event: any): void {}

  save(event: SaveFormEvent) 
  {
    if (!event.isFormValid) 
    {
      this.baseForm.markAllFieldsAsTouched();
      this.baseForm.showValidationSummary(true);
      this.dialogService.showPopup(POP_UP_CODES.common.validationError);
    }
    const saveDataRequest : VptasSpecialistProviderInformationSaveDataRequest =
    {
        template: this.templateId,
          versionNumber: this.versionNo,
          id: this.id,
          response: event.model,
          expectedLastUpdateTime: event.lastUpdatedTime,
          isSubmit: false,
          specialistId: this.specialistId
    };
    this.saveData(saveDataRequest);
  }

  cancel(event: any) {
    this.exit();
  }

  private saveData(request: VptasSpecialistProviderInformationSaveDataRequest) {
      this.spinnerService.showSpinner();
      this.dataService.saveData(API_ENDPOINTS.vptasSpecialist.saveProviderInformation, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {            
            this.router.navigate([ROUTE_CONSTANTS.VptasSpecialist.prefix, this.specialistId ]);          
          }
        });
  }

  private exit(ignoreUnsavedChanges = false): void {
    this.router.navigate([ROUTE_CONSTANTS.VptasSpecialist.prefix, this.specialistId ]); 
  }
}
